<template>
    <div>
        <view-item v-if="!!item" :item="item" @success="resetItems" @cancel="item = false"
            @delete-item="deleteType"></view-item>

        <list-items v-else title="Master Bank" @show-item="showItem" ref="table">
            <!-- <b-button block variant="primary" v-if="hasPermissionCreate" @click="item = {}"><img v-b-tooltip.hover
                    :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button> -->
                    <b-button id="add-master-bank" block variant="primary"  @click="item = {}"><img v-b-tooltip.hover
                        :title="$addLabel()" src="@/assets/images/icon/blue-add.svg" /></b-button>
        </list-items>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'MasterBank',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data() {
        return {
            item: null,
        }
    },
    computed: {
        componentName(){
            return this.$translate('master_bank')
        },
        items() {
            const items =this.$store.state.masterBank.items
            return items
        },
    },
    methods: {
        async doSearch() {
            await this.$store.dispatch('masterBank/fetchAll')
        },
        showItem(id) {
            console.log('idssss', id)
            this.item = this.items.find(x => x.id === id)
            this.$store.state.masterBank.item = this.item; 
            console.log('state item', this.$store.state.masterBank.item)
        },
        resetItems(status) {
            this.genericToast(
                this.componentName,
                status,
                'success',
                `${this.componentName} ${status.toLowerCase()} ${this.$translate('succcessfully')}`
            )
            this.item = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
